import { createContext, useContext } from 'react'

export type ActionMode = 'intent' | 'add_product' | 'checkout'

export interface OmpActionContextValue {
  mode: ActionMode | null
  title: string
  item: any | null
  product: any | null
  busy: boolean
  // Blocks re-render: auto-submitting steps would loop on it.
  error: string | null
  retry: () => void
  intent: number | null
  startAction: (item: any, intent: number, title: string) => void
  openAddProduct: (product: any, title?: string) => void
  // Buy Again: cart the item, then run the funnel's checkout step.
  openCheckout: (item: any, title?: string) => void
  // Checkout supplies its own params alongside the input.
  submitCheckout: (input: any, params: Record<string, any>) => void
  submitInput: (input: any, data?: Record<string, any>, campaignProduct?: any) => void
  /** Campaign product picked on the preceding exchange step, if any. */
  exchangeProduct: any | null
  submitData: (data: Record<string, any>, mainItem?: any) => void
  /** Server undo of one step, staying in the drawer. Back, not close. */
  stepBack: () => void
  cancel: () => void
  close: () => void
}

export const OmpActionContext = createContext<OmpActionContextValue | null>(null)

export function useOmpActions(): OmpActionContextValue {
  const ctx = useContext(OmpActionContext)
  if (!ctx) {
    throw new Error('useOmpActions must be used within OmpActionsProvider')
  }
  return ctx
}
